/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Button,
} from 'reactstrap';
import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { post } from '../../helpers/api_helper';
import * as urls from '../../helpers/url_helper';

export default class NewPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
    };
  }

  render() {
    // meta title
    document.title = 'Set Account Pin';

    const reset = async (values) => {
      this.setState({ loading: true });

      try {
        await post(`${urls.POST_PASSWORD_RESET}${this.props.location.search}`, values);

        this.props.history.push('/login');
      } catch (error) {
        if (error.response.status === 401) {
          this.setState({ error: 'Invalid or expired token' });
        } else {
          this.setState({ error: error.message });
        }
      } finally {
        this.setState({ loading: false });
      }
    };

    const ValidationSchema = Yup.object().shape({
      pin: Yup.string()
        .matches(/^[0-9]+$/i, 'Numbers only!')
        .matches(/^.{5}.+$/i, 'Must be at least 6 characters')
        .required('Pin is required'),
      confirm: Yup.string()
        .oneOf([Yup.ref('pin'), null], 'Pins must match')
        .required('Confirm Pin is required'),
    });

    let em = (
      <Alert color="danger" className="mt-3" isOpen={!isNull(this.state.error)}>
        {this.state.error}
      </Alert>
    );

    if (this.state.error != null) { // Make part bold
      const match = this.state.error.match(/(.*)<<<(.+)>>>(.*)/);

      if (match !== null) {
        em = (
          <Alert color="danger" className="mt-3" isOpen>
            {match[1]}
            <strong>{match[2]}</strong>
            {match[3]}
          </Alert>
        );
      }
    }

    return (
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row style={{ marginTop: '70px' }} className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div>
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bxs-shield h1 mb-0 text-primary" />
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <div className="text-center">
                          <h4>Set Your New Pin</h4>
                        </div>
                        { em }
                        <Formik
                          enableReinitialize
                          initialValues={{
                            pin: '',
                            confirm: '',
                          }}
                          validationSchema={ValidationSchema}
                          onSubmit={(values) => {
                            reset(values);
                          }}
                        >
                          {({
                            touched, errors,
                          }) => (
                            <Form className="mt-3" autoComplete="off">
                              <div className="row mt-4 mb-4">
                                <Label
                                  for="pin"
                                  className="col-sm-5 col-form-label"
                                >
                                  New Pin
                                </Label>
                                <Col sm={7}>
                                  <Field
                                    type="password"
                                    className={`form-control ${(errors.pin && touched.pin ? 'is-invalid' : '')}`}
                                    id="pin"
                                    name="pin"
                                  />
                                  <ErrorMessage
                                    name="pin"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </Col>
                              </div>

                              <div className="row mt-4 mb-4">
                                <Label
                                  for="confirm"
                                  className="col-sm-5 col-form-label"
                                >
                                  Confirm Pin
                                </Label>
                                <Col sm={7}>
                                  <Field
                                    type="password"
                                    className={`form-control ${(errors.confirm && touched.confirm ? 'is-invalid' : '')}`}
                                    id="confirm"
                                    name="confirm"
                                  />
                                  <ErrorMessage
                                    name="confirm"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </Col>
                              </div>

                              <div className="row mt-5">
                                <Col sm={12}>
                                  <div className="text-center">
                                    <Button
                                      type="submit"
                                      color="primary"
                                      className="w-md"
                                      disabled={this.state.loading}
                                    >
                                      { this.state.loading ? 'Loading...' : 'Set Pin' }
                                    </Button>
                                  </div>
                                </Col>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
